// 子仓库 - 用户事件
import to from 'await-to-js';
import * as apis from "@/api/interface/market";

export default {
  namespaced: true,
  state: () => ({
    eventList: undefined, //短险监控所属期 - 列表
    ospList: undefined, //营销归属 - 列表
    msgList: undefined, //消息内容 - 列表
    statsConversionList: undefined, //转化归因 - 转化 - 列表
    statsRecordList: undefined, //转化归因 - 记录 - 列表
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 用户事件 - 列表
    async getEventList(ctx, payload = {}) {
      const [err, res] = await to (apis.getEventList(payload));
      ctx.commit("update", {
        eventList: !err && res.data ? res.data : undefined,
      });
    },
    // 用户事件 - 下拉选项
    async getEventPageOptions(_, payload = {}) {
      const [, res] = await to (apis.getEventPageOptions(payload));
      return res;
    },
    // 用户事件 - 新增、修改
    async eventAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.eventAddOrUpdate(payload));
      return res;
    },


    // 营销归属 - 列表
    async getOspList(ctx, payload = {}) {
      const [err, res] = await to (apis.getOspList(payload));
      ctx.commit("update", {
        ospList: !err && res.data ? res.data : undefined,
      });
    },
    // 营销归属 - 下拉选项
    async getOspPageOptions(_, payload = {}) {
      const [, res] = await to (apis.getOspPageOptions(payload));
      return res;
    },
    // 营销归属 - 新增、修改
    async ospAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.ospAddOrUpdate(payload));
      return res;
    },


    // 消息内容 - 列表
    async getMsgList(ctx, payload = {}) {
      const [err, res] = await to (apis.getMsgList(payload));
      ctx.commit("update", {
        msgList: !err && res.data ? res.data : undefined,
      });
    },
    // 消息内容 - 下拉选项
    async getMsgPageOptions(_, payload = {}) {
      const [, res] = await to (apis.getMsgPageOptions(payload));
      return res;
    },
    // 消息内容 - 文件上传
    async msgUploadFile(_, payload=[]) {
      const [, res] = await to (apis.msgUploadFile(...payload));
      return res;
    },


    // 转化归因 - 转化 - 列表
    async getStatsConversionList(ctx, payload = {}) {
      const [err, res] = await to (apis.getStatsConversionList(payload));
      ctx.commit("update", {
        statsConversionList: !err && res.data ? res.data : undefined,
      });
    },
    // 转化归因 - 记录 - 列表
    async getStatsRecordList(ctx, payload = {}) {
      const [err, res] = await to (apis.getStatsRecordList(payload));
      ctx.commit("update", {
        statsRecordList: !err && res.data ? res.data : undefined,
      });
    },
  },
  modules: {},
};
